import React from 'react'
import './footer.css'

const Footer = (props) => {
  const currentYear = new Date().getFullYear()

  const scrollToSection = (id) => {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-grid">

            {/* Brand Section */}
            <div className="footer-column footer-brand-section">
              <div className="footer-logo-wrapper">
                <span className="footer-brand-name">Giga Owo Ori Hotel</span>
                <span className="footer-brand-tagline">
                  Fodo, Gunungsitoli — North Sumatra
                </span>
              </div>
              <p className="footer-description">
                Nikmati pengalaman menginap yang nyaman dan berkesan di jantung
                Gunungsitoli. Kami menghadirkan kehangatan dan pelayanan terbaik
                untuk setiap tamu.
              </p>
              <div className="footer-social-links">
                <a href="https://wa.me/6281384813636" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                  <div className="footer-social-item">
                    <svg fill="none" width="20" height="20" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="m3 21l1.65-3.8a9 9 0 1 1 3.4 2.9z"></path>
                      <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0za5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"></path>
                    </svg>
                  </div>
                </a>
                <a href="https://instagram.com/gigaowooorihotel" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <div className="footer-social-item">
                    <svg fill="none" width="20" height="20" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="2" rx="5" ry="5" width="20" height="20"></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                    </svg>
                  </div>
                </a>
                <a href="https://facebook.com/gigaowooorihotel" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <div className="footer-social-item">
                    <svg fill="none" width="20" height="20" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-column">
              <h3 className="footer-heading">Quick Links</h3>
              <nav className="footer-nav">
                <ul className="footer-nav-list">
                  {[
                    { label: 'Home', id: 'hero' },
                    { label: 'Our Rooms', id: 'rooms' },
                    { label: 'Facilities', id: 'facilities' },
                    { label: 'Gallery', id: 'gallery' },
                    { label: 'Contact Us', id: 'contact' },
                  ].map(({ label, id }) => (
                    <li key={id} className="footer-nav-item">
                      <button
                        onClick={() => scrollToSection(id)}
                        className="footer-nav-link"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                      >
                        <span>{label}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            {/* Get In Touch */}
            <div className="footer-column">
              <h3 className="footer-heading">Get In Touch</h3>
              <div className="footer-contact-list">
                <div className="footer-contact-item">
                  <div className="footer-icon-box">
                    <svg fill="none" width="18" height="18" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle r="3" cx="12" cy="10"></circle>
                    </svg>
                  </div>
                  <span className="footer-contact-text">
                    Fodo, Gunungsitoli, North Sumatra, Indonesia
                  </span>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-box">
                    <svg fill="none" width="18" height="18" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                  <a href="tel:+6281384813636" className="footer-contact-text" style={{ textDecoration: 'none', color: 'inherit' }}>
                   +62 813 8481 3636
                  </a>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-box">
                    <svg fill="none" width="18" height="18" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                  </div>
                  <a href="mailto:info@gigaowooorihotel.com" className="footer-contact-text" style={{ textDecoration: 'none', color: 'inherit' }}>
                    info@gigaowooorihotel.com
                  </a>
                </div>
              </div>
            </div>

          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-copyright">
              <span>© {currentYear} Giga Owo Ori Hotel. All rights reserved.</span>
            </div>
            <div className="footer-attribution">
              <span>Powered by </span>
              <span className="footer-partner">BeAr Management</span>
            </div>
          </div>

        </div>
      </footer>
    </div>
  )
}

export default Footer